import {Injectable} from '@angular/core';
import {ApiImplementation} from '../api/api-implementation.service';
import {ApiService} from '../api/api.service';
import {Paginator} from '../../models/paginator';
import {MessageImageData} from '../../models/message-image-data';
import {PusherService} from '../pusher/pusher.service';
import {Entity} from '../../models/entity';
import {Message} from '../../models/message';
import {Model} from '../../models/model';

@Injectable({
  providedIn: 'root',
})
export class MessagesService extends ApiImplementation {

  protected base: string       = 'v1/messages';
  protected primaryKey: string = 'id';

  constructor(protected api: ApiService,
              protected pusher: PusherService,
  ) {
    super(api)
  }

  model(data?) {
    return new Message(data);
  }

  paginator(data) {
    return new Paginator<Message>(data);
  }


  // public groups(group : Group){
  //   return this.api.get(this.base + '/' + group.id + '/groups').then( data => {
  //     return this.groupService.transform(data['data']);
  //   })
  // }
  //

  // public all(limit = 100, page = 1): Promise<Paginator<Group>> {
  //   return super.all(limit, page) as Promise<Paginator<Group>>;
  // }

  public get(id: number) {
    return super.get(id) as Promise<Message>;
  }

  public delete(group: Message) {
    return super.delete(group);
  }

  public save(group: Message): Promise<Message> {
    return super.save(group) as Promise<Message>;
  }

  public send(entities: Array<Model>, body: string, type: string, images: Array<MessageImageData>) {
    return this.api.post(this.base, {
      entities: entities,
      body:     body,
      type:     type,
      images:   images,
    });
  }

  public all(entity, type, limit = null, page = null) {
    if (limit && page) {
      return this.api.get('v1/entities/' +
                          entity.id + '/messages/' + type + '?limit=' + limit + '&page=' + page + '&sort=-created_at');
    } else {
      return this.api.all('v1/entities/' + entity.id + '/messages/' + type);
    }
  }

  public onMessageEntity(entity: Entity, func) {
    // const channel = this.pusher.subscribe('message.' + entity.id, true);
    // // Bind on message create event
    // channel.bind('chat.message.created', (data) => {
    //     if (data != null && data['message'] != null) {
    //         return func(this.transform(data['message']));
    //     }
    // });
    // return channel;
  }

  public unsubscribe(entity: Entity, channel: any) {
    this.pusher.unsubscribe('message.' + entity.id, true);
    channel.unbind();
  }

  public addPictures(id, pictures: Array<File>) {
    const vm       = this;
    const promises = [];

    return new Promise((resolve, reject) => {
      for (const picture of pictures) {

        const formData: FormData = new FormData();
        formData.append('image', picture)
        const promise = vm.api.post(vm.base + '/' + id + '/image', formData);
        promises.push(promise);
      }

      Promise.all(promises).then(() => {
        resolve();
      });
    })

  }
}
